import { ComponentConfig } from "@measured/puck"
import { message, Select } from "antd"
import { useEffect, useState } from "react"
import { fetchCategories, fetchPostByCategories, filterOption } from "../../../../external-components"
import { Pagination, PostData } from "../../../types"
import { ArticlesProps, RenderSinglePost } from "./RenderConfig"

const SelectCategoryAndPost = ({ value, onChange }: any) => {
  const [optionCategories, setOptionCategories] = useState<{ value: string; label: string }[]>([])
  const [postOptions, setPostOptions] = useState<{ value: string; label: string }[]>([])
  const [selectedCategory, setSelectedCategory] = useState<string | undefined>(undefined)

  const fetchCategory = async (paginate?: Pagination, searchTerm?: string) => {
    try {
      const response = await fetchCategories(searchTerm, "undefined")
      setOptionCategories(
        (response as { data: { id: string; attributes: { name: string } }[] }).data.map(
          (category: { id: string; attributes: { name: string } }) => ({
            value: category.id as string,
            label: category.attributes.name,
          }),
        ),
      )
    } catch (err) {
      message.error("Failed to fetch categories. Please try again.")
    }
  }

  const fetchPostsByCategory = async (categoryId: string) => {
    try {
      if (!categoryId) {
        setPostOptions([])
        return
      }

      const response = await fetchPostByCategories([categoryId])
      const posts = response?.data

      if (posts && posts.length > 0) {
        setPostOptions(
          posts.map((post: PostData) => ({
            value: post.id,
            label: post.attributes.name,
          })),
        )
      } else {
        message.warning("No posts found for the selected category.")
        setPostOptions([])
      }
    } catch (err) {
      message.error("Failed to fetch posts. Please try again.")
    }
  }

  useEffect(() => {
    fetchCategory()
  }, [])

  useEffect(() => {
    if (selectedCategory) {
      fetchPostsByCategory(selectedCategory)
    }
  }, [selectedCategory])

  const handleCategoryChange = async (selectedValue: string | null) => {
    setSelectedCategory(selectedValue || undefined)
    onChange({ post: undefined })
  }

  const handlePostChange = (selectedValue: string | null) => {
    onChange({ post: selectedValue || undefined })
  }

  return (
    <div>
      <Select
        showSearch
        style={{ minWidth: "14rem" }}
        placeholder="Select Category"
        optionFilterProp="children"
        filterOption={filterOption}
        options={optionCategories}
        allowClear
        value={value.category}
        onChange={handleCategoryChange}
      />
      {selectedCategory && (
        <Select
          showSearch
          placeholder="Select Post"
          value={value.post}
          onChange={handlePostChange}
          options={postOptions}
          style={{ minWidth: "14rem", marginTop: "1rem" }}
          allowClear
        />
      )}
    </div>
  )
}

export const SinglePost: ComponentConfig<ArticlesProps> = {
  label: "CaoCao | Single Post",
  fields: {
    category: {
      label: "Category and Post",
      type: "custom",
      render: ({ value, onChange, field }: any) => {
        return <SelectCategoryAndPost value={value || { post: undefined }} onChange={onChange} />
      },
    },
    type: {
      label: "Layout Type",
      type: "select",
      options: [
        { label: "Fluid", value: "fluid" },
        { label: "Custom", value: "custom" },
        { label: "Boxed", value: "boxed" },
      ],
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    gapCustom: "83px",
    heightContact: "388px",
    type: "fluid",
    className: "",
  },
  ...RenderSinglePost,
}
